import router from '../router'
import Vue from 'vue'

export const actions = {
    auth ({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('clearError');
            Vue.prototype.$axios.get('/auth', payload)
                .then(response => {
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
    login({commit}, payload) {
        commit('clearAuth');
        commit('clearUser');
        commit('clearError');

        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            Vue.prototype.$axios.post('/login', payload)
                .then(response => {
                    commit('setLoading', false);
                    commit('setUser', response.data.user);
                    commit('setAuth', true);
                    resolve(response)
                })
                .catch(error => {
                    // commit('setError', error.message);
                    commit('setLoading', false);
                    commit('clearUser');
                    reject( error );
                });
        })
    },
    serverLog (payload) {
        Vue.prototype.$axios.post('/log', payload)
            .then(() => {
            })
    },
    performLogout ({commit}) {
        Vue.prototype.$axios.get('/logout');
        commit('setLoading', false);
        commit('clearError');
        commit('clearUser');
        commit('clearAuth');
        sessionStorage.clear();

        delete Vue.prototype.$axios.defaults.headers.common['Authorization'];

        router.push('/login')
    },
    userQuery ({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('clearUsers');
            // commit('clearTransactions');
            Vue.prototype.$axios.post('/pos/users/query', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        commit('setUsers', response.data);
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
    transferQuery ({commit}, payload) {
        return new Promise((resolve, reject) => {
            console.log(payload)
            commit('setLoading', true);
            commit('clearTransfers');
            Vue.prototype.$axios.post(
                '/pos/users/transfer', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        commit('setTransfers', response.data);
                        resolve(response.data)
                    } else {
                        reject(response.data);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });

        })
    },

    addUser ({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            Vue.prototype.$axios.post('/pos/users/add', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
    modifyUser ({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            // commit('clearTransactions');
            Vue.prototype.$axios.post('/pos/users/modify', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
    deleteUser ({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            // commit('clearTransactions');
            Vue.prototype.$axios.post('/pos/users/delete', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
};